module.exports = __webpack_public_path__ + "static/onboarding-fc6ec9df2c70b6adc962894ee1047267.svg";